
















































































































































































































































































































































































import { Component, Vue, Mixins, Watch, Provide } from "vue-property-decorator";
import {
  productList,
  checktProductClass,
  createProduct,
  updateProduct,
  updateInfo,
  productCategoryAll,
} from "@/api/productList";
import { CreateProduct } from "@/types/api/productList";
import { freightSelectByObj, freightDel } from "@/api/freight";
import quillEditorImgUpload from "@/utils/quillEditorImgUpload";
import print from "@/utils/print";
import { allParentList, checkDict } from "@/api/system";
// 混入
import Loading from "@/mixins/loading";
// 组价

// 工具
import copy from "@/utils/deepCopy";
import debounce from "@/utils/debounce";
import inputPrice from "@/utils/inputPrice";
import { FormItem } from "element-ui";

@Component({
  name: "addProdcut",
  components: {},
})
export default class AddProdcut extends Mixins(Loading) {
  pid = null;
  active = 1; // 步骤
  editorOption = {};
  dictionary: Array<any> = [];
  dialogImageUrl = "";
  dialogVisibleImg = false;
  productTypeList = [
    { name: "折扣类型", id: 1 },
    { name: "无折扣类型", id: 2 },
  ];
  freightList = []; // 运费模板
  mergeList: Array<any> = [];

  // 初始化模板
  initForm: any = {
    shareDesc: "",
    defaultSku: 0,
    defaultSkuName: "",
    deleteStatus: 0,
    detailDesc: "",
    freightTemplateId: 0,
    keywords: "",
    marketPrice: 0,
    name: "",
    newStatus: 0,
    note: "",
    pictures: [],
    picture: [],
    pmsProductDesc: {
      description: "",
    },
    pmsProductSkus: [],
    previewStatus: 0,
    price: 0,
    productCategoryId: "",
    productCategoryName: "",
    publishStatus: 0,
    recommandStatus: 0,
    sale: 0,
    shippingMethod: "",
    sort: 0,
    subTitle: "",
    tags: "", // 商品类型
    verifyStatus: 0,
    weight: 0,
    stylesName: "",
  };

  styleList: Array<{ name: string; pic: string }> = []; // 款式列表
  skuList: Array<{ name: string }> = []; // 规格列表
  productFrom = copy(this.initForm); // 添加商品的表单
  classifyList = []; // 分类列表
  type: string = "add"; // add：添加   edit：编辑

  rules: any = {
    name: [
      { required: true, message: "请输入商品名称", trigger: "blur" },
      {
        min: 1,
        max: 20,
        message: "长度在 1 到 20 个字符",
        trigger: "blur",
      },
    ],
    productCategoryId: [
      { required: true, message: "请选择商品分类", trigger: "change" },
    ],
    picture: [{ required: true, message: "请上传商品照片", trigger: "change" }],
    priceType: [
      {
        required: true,
        message: "请选择商品类型",
        trigger: "change",
      },
    ],
    tags: [{ required: true, message: "请设置关联", trigger: "change" }],
    shippingMethod: [
      { required: true, message: "请选择配送方式", trigger: "change" },
    ],
  };

  created() {
    this.type = "add";
    // 添加商品的表单
    this.editorOption = quillEditorImgUpload("product");
    this.getFreight();
    this.getClassify();
    this.getAllDictionary();
  }

  /**
   * watch监听
   */
  @Watch("$route", { immediate: true })
  routechange() {
    this.getClassify();
    this.$nextTick(()=>{
      this.hideLoading();
    })
  }


  get shippingMethodArr() {
    return this.productFrom.shippingMethod.split(",");
  }

  set shippingMethodArr(val) {
    this.productFrom.shippingMethod = val.join(",");
  }

  get isCollapse() {
    return this.$store.getters.isCollapse;
  }

  // 在上架商品对话框：里删除商品图片
  handleRemove(file: any, fileList: any) {
    this.productFrom.picture  = fileList.map((e: any) => {
      if (e.response) {
        return {
          name: e.response.data.name,
          url: this.$uploadImgUrl + e.response.data.url,
          originUrl: e.response.data.url,
        };
      } else {
        return e;
      }
    });
  }
  // 在上架商品对话框：预览图片
  handlePictureCardPreview(file: any) {
    this.dialogImageUrl = file.url;
    this.dialogVisibleImg = true;
  }
  // 在上架商品对话框：限制图片上传数量提示
  handleExceed() {
    this.$message.error("最多只能上传9张图片");
  }
  // 在上架商品对话框：图片上传成功
  onSuccess(res: any, file: any, fileList: any) {
    if (!Array.isArray(this.productFrom.picture)) {
      this.productFrom.picture = [];
    }
    this.productFrom.picture.push({
      name: res.data.name,
      url: this.$uploadImgUrl + res.data.url,
      originUrl: res.data.url,
    });
  }

  // 图片上传成功
  handleAvatarSuccess(res: any, file: any, styleName: any) {
    styleName.pic = res.data.url;
  }

  // 图片上传之前拦截
  beforeAvatarUpload(file: any) {
    const isLt2M = file.size / 1024 / 1024 < 1;
    if (!isLt2M) {
      this.$message.error("上传头像图片大小不能超过 1MB!");
    }
    return isLt2M;
  }

  // 表头样式
  headerCellStyle() {
    return {
      background: "#eef1f6",
      color: "#606266",
      textAlign: "center",
    };
  }
  // 列表样式
  cellStyle() {
    return {
      textAlign: "center",
    };
  }

  // 获取运费模板
  getFreight() {
    freightSelectByObj().then((res) => {
      // templateCode相同的就合并，因为是属于一个区域的
      let data = res.data;
      this.freightList = data.reduce((pre: any, cur: any) => {
        // 查看是否存在
        let index = pre.findIndex(
          (f: any) => f.templateCode == cur.templateCode
        );
        // 存在则在当前对象内容添加
        if (index > -1) {
          pre[index].region += "," + cur.region; // 地区code拼接
          pre[index].data.push({
            region: cur.region,
            continueFee: cur.continueFee,
            continueValue: cur.continueValue,
            firstFee: cur.firstFee,
            firstValue: cur.firstValue,
          });
        } else {
          // 不存在则添加
          pre.push({
            ...cur,
            data: [
              {
                region: cur.region,
                continueFee: cur.continueFee,
                continueValue: cur.continueValue,
                firstFee: cur.firstFee,
                firstValue: cur.firstValue,
              },
            ],
          });
        }
        return pre;
      }, []);
    });
  }

  // 获取详情
  getProductDetail(pid: any) {
    let id: number = Number(pid);
    updateInfo({ id: id }).then((res: any) => {
      let item = res.data;
      // 处理图片为数组类型
      item.picture = (item.pictures && item.pictures.split(",")) || [];
      item.picture = item.picture.map((e: string) => ({
        name: e,
        url: this.$uploadImgUrl + e,
        originUrl: e,
      }));
      // 标签切割
      item.tags = item.tags
        ? item.tags.split(",").map((e: any) => Number(e))
        : [];
      // 款式

      const styles = item.stylesName.split(",");
      const pics = item.stylePictureList;
      styles.forEach((e: any, i: number) => {
        this.styleList.push({
          name: styles[i],
          pic: pics[i],
        });
      });

      this.mixPmsProductSkus();

      item.pmsProductSkus.forEach((pms: any) => {
        let isAdd = this.skuList.findIndex((sku) => {
          return sku.name == pms.name;
        });
        if (isAdd > -1) {
          return;
        }
        this.skuList.push({
          name: pms.name,
        });
      });

      // 商品描述
      if (!item.pmsProductDesc) {
        item.pmsProductDesc = {
          description: "",
          productId: item.id,
        };
      }
      // 分类如果是0则转为空字符串
      item.productCategoryId =
        item.productCategoryId == 0 ? "" : item.productCategoryId;
      item.productShowCategoryIds = item.productShowCategoryIds
        ? item.productShowCategoryIds.split(",")
        : [];
      item.productShowCategoryIds = item.productShowCategoryIds.map(Number);
      this.productFrom = item;
      this.hideLoading();
    });
  }

  @Watch("styleList", { deep: true })
  @Watch("skuList", { deep: true })
  searchValue() {
    this.mixPmsProductSkus();
  }
  mixPmsProductSkus() {
    let pmsProductSkus = this.productFrom.pmsProductSkus;
    let temp: Array<any> = [];
    let styleToSkuMap: Array<any> = [];
    this.styleList.forEach((style) => {
      this.skuList.forEach((sku) => {
        styleToSkuMap.push({
          pic: style.pic,
          style: style.name,
          sku: sku.name,
        });
      });
    });

    styleToSkuMap.forEach((item) => {
      let styleToSku = {
        styleName: item.style,
        name: item.sku,
        pic: item.pic,
        stock: 0,
        sort: 0,
        price: 0,
      };
      pmsProductSkus.find((pms: any) => {
        if (pms.name == item.sku && pms.styleName == item.style) {
          styleToSku = pms;
          return true;
        }
        return false;
      });
      temp.push(styleToSku);
    });
    temp = temp.sort((a: any, b: any) => {
      var nameA = a.styleName.toUpperCase(); // ignore upper and lowercase
      var nameB = b.styleName.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });

    this.productFrom.pmsProductSkus = temp;
    this.getSpanData();
  }

  // 获取分类
  async getClassify() {
    productCategoryAll().then((res) => {
      this.classifyList = res.data;
    });
  }

  // 获取数据字典
  getAllDictionary() {
    checkDict({
      parentId: 2,
      pageNum: 1,
      pageSize: 999,
    }).then((res) => {
      this.dictionary = res.data.list;
    });
  }

  // 下一步
  lastStep() {
  let ruleForm: any = this.$refs["ruleForm"];
    let temp: any = this.productFrom;
    let skuList = this.skuList;
    let styleList = this.styleList;
    const isSKu = skuList.find((el) => {
      return el.name.length == 0;
    });
    const isStyle = styleList.find((el) => {
      return el.name.length == 0 || el.pic.length == 0;
    });
    if(isStyle || isSKu){
        this.$message.error("请完善款式或规格！");
        return false;
    }

    const isPrice =  temp.pmsProductSkus.find((e: any) => {
        return e.price <= 0;
    });
    if(isPrice){
        this.$message.error('商品价格需要大于0！');
        return false;
    }

    ruleForm.validate((valid: any) => {
      if (valid) {
        this.active = 2;
      } else {
        return false;
      }
    });
  }
  firstStep() {
    this.active = 1;
  }

  // 发布
  confirmProduct() {
    this.showLoading();
    let temp: any = this.productFrom;
    this.productFrom.pictures = temp.picture
      .map((e: any) => {
        if (e.response) {
          return e.response.data.url;
        } else if (e.originUrl) {
          return e.originUrl;
        }
      })
      .toString();
    this.productFrom.productCategoryId = temp.productCategoryId;
    let tempIds = temp.productShowCategoryIds;
    tempIds.push(temp.productCategoryId);
    tempIds = Array.from(new Set(tempIds));
    this.productFrom.productShowCategoryIds = tempIds.join(",");
    this.productFrom.tags = temp.tags.toString();
    this.productFrom.stylesName = this.styleList
      .map((e: any) => e.name)
      .toString();
    let caName: any = this.classifyList.filter(
      (e: any) => e.id == temp.productCategoryId
    )[0];
    this.productFrom.productCategoryName = caName.name;

    let prom;
    if (this.type == "add") {
      temp.pmsProductSkus.forEach((e: any) => {
        delete e.id;
        delete e.productId;
      });

      prom = createProduct(temp);
    } else {
      temp.pmsProductSkus.forEach((e: any) => {
        e.id = e.id == 0 ? null : e.id;
        e.productId = temp.id;
      });
      prom = updateProduct(temp);
    }
    // 获取异步信息统一处理
    prom
      .then((res) => {
        this.$message.success("发布成功");
        // 初始化
        this.pid = null;
        this.active = 1;
        this.productFrom = copy(this.initForm);
        this.skuList = [];
        this.styleList = [];
        this.vieProductList();
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  vieProductList() {
    this.$router.push({
      path: "/productList",
    });
  }

  addCategory() {
    this.$router.push({
      path: "/productCategory",
    });
  }

  // 添加规格
  addSku() {
    this.skuList.push({
      name: "",
    });
  }

  delSku(index: number) {
    this.skuList.splice(index, 1);
  }

  // 添加规格
  addStyle() {
    this.styleList.push({
      pic: "",
      name: "",
    });
  }

  delStyle(index: number) {
    this.styleList.splice(index, 1);
  }

  // 输入商品详情信息
  inputDesc(val: { html: string }) {
    this.productFrom.pmsProductDesc.description = val.html;
  }

  // 限制只能输入数字，而且只能保留两位小数
  limitInput(val: string, index: number, key: number, type: string) {
    this.productFrom.pmsProductSkus[index][key] = inputPrice(val, type);
  }
  // 限制只能输入数字
  inputValue(val: string, index: number) {
    this.productFrom.pmsProductSkus[index].stock = inputPrice(val, "number");
  }

  getSpanData() {
    let tableData = this.productFrom.pmsProductSkus;
    let tempIndex = 0;
    this.mergeList = [];
    tableData.forEach((item: any, index: any) => {
      if (index === 0) {
        // 第一行必须存在
        this.mergeList.push(1);
        tempIndex = 0;
      } else {
        if (item.styleName === tableData[index - 1].styleName) {
          this.mergeList[tempIndex]++;
          this.mergeList.push(0);
        } else {
          this.mergeList.push(1);
          tempIndex = index;
        }
      }
    });
  }

  objectSpanMethod(tabSpan: any) {
    if (tabSpan.columnIndex == 0) {
      const col_num = this.mergeList[tabSpan.rowIndex];
      return {
        rowspan: col_num, // n行单元格的第一个直接占满n行
        colspan: col_num > 0 ? 1 : 0,
      };
    }
  }
}
